import React from "react";
import { useFormContext } from "react-hook-form";
import AccordionCard from "../../../../../components/common/PL/AccordionCard/AccordionCard";
import BundleKey from "../../../../../translation/bundleKey";
import { EntryRegistrationFormValues } from "../types";
import { RegistrationMode } from "../../registroIngresoNavigation";
import FacialDeviceChecklist from "./FacialDeviceChecklist/FacialDeviceChecklist";
import PermanenceTimePicker from "./PermanenceTimePicker/PermanenceTimePicker";
import { useStore } from "../../../../../hooks/useStore";
import "./AccessRulesForm.css";

type AccessRulesFormProps = {
  formId: string;
  mode: RegistrationMode;
  isTransport?: boolean;
};

const AccessRulesForm = ({ formId, mode, isTransport = false }: AccessRulesFormProps) => {
  const { watch, setValue } = useFormContext<EntryRegistrationFormValues>();
  const { authStore } = useStore();

  const enabledFacialDevices = watch("enabledFacialDevices") || [];
  const entryPermanenceTimePreset = watch("entryPermanenceTimePreset");
  const entryPermanenceTimeCustom = watch("entryPermanenceTimeCustom");
  const exitPermanenceTimePreset = watch("exitPermanenceTimePreset");
  const exitPermanenceTimeCustom = watch("exitPermanenceTimeCustom");

  const facialDevices = (authStore.hikvisions || []).map((h: any) => ({
    id: h.key,
    label: h.name,
  }));

  const titleKey =
    mode === "exit" ? BundleKey.ACCESS_RULES_FORM_TITLE_EXIT : BundleKey.ACCESS_RULES_FORM_TITLE;

  return (
    <AccordionCard
      id={`${formId}-access-rules`}
      titleKey={titleKey}
      number={isTransport ? 3 : 4}
      // Arranca minimizado en todos los tipos de acceso (ingreso y egreso): se despliega a mano
      // cuando hace falta.
      expanded={false}
    >
      <div className="accessRulesFormContainer">
        <div className="accessRulesGrid">
          <div className="accessRulesColumn">
            <h4 className="accessRulesColumnTitle">Dispositivos habilitados a acceder</h4>
            <FacialDeviceChecklist
              devices={facialDevices}
              value={enabledFacialDevices}
              onChange={(ids) => setValue("enabledFacialDevices", ids)}
              disabled={mode === "exit"}
            />
          </div>

          <div className="accessRulesColumn">
            <h4 className="accessRulesColumnTitle">Tiempos de permanencia</h4>
            <PermanenceTimePicker
              label="Lectores de entrada"
              preset={entryPermanenceTimePreset}
              custom={entryPermanenceTimeCustom}
              onPresetChange={(preset) => setValue("entryPermanenceTimePreset", preset)}
              onCustomChange={(custom) => setValue("entryPermanenceTimeCustom", custom)}
              disabled={mode === "exit"}
            />
            <PermanenceTimePicker
              label="Lectores de salida"
              preset={exitPermanenceTimePreset}
              custom={exitPermanenceTimeCustom}
              onPresetChange={(preset) => setValue("exitPermanenceTimePreset", preset)}
              onCustomChange={(custom) => setValue("exitPermanenceTimeCustom", custom)}
              disabled={mode === "exit"}
            />
          </div>
        </div>
      </div>
    </AccordionCard>
  );
};

export default AccessRulesForm;
